import api from 'api'
import { RENOVATIONS_RECIEVED, RENOVATION_SAVED, RENOVATION_DELETED, RENOVATION_UNLOADED } from './types'

export const renovationSaved = data => ({
  type: RENOVATION_SAVED,
  data
})

export const renovationDataRecieved = data => ({
  type: RENOVATIONS_RECIEVED,
  data
})

export const renovationDeleted = data => ({
  type: RENOVATION_DELETED,
  data
})

export const renovationsDataUnloaded = data => ({
  type: RENOVATION_UNLOADED
})

export const unloadRenovations = () => dispatch => {
  dispatch(renovationsDataUnloaded())
}

export const deleteRenovation = data => dispatch =>
  api.bmc.activities.deleteActivity(data).then(()=>{
    dispatch(renovationDeleted(data))
  })

export const getRenovations = planid => dispatch =>
  api.bmc.activities.getActivities(planid, 'renovation').then(res => {
    dispatch(renovationDataRecieved(res))
  })

export const saveRenovation = data => dispatch =>
  api.bmc.activities.postActivity(data).then(res=> {
    dispatch(renovationSaved(res))
  })
